<template>
    <div class="article-wrapper">
        <article class="content-article">
            <figure class="featured">
                <span v-if="this.offer && this.offer.MerchantImageURL" class="img-name" :style="{ backgroundImage: 'url(' + this.offer.MerchantImageURL + ')' }"></span>
            </figure>
            <div class="article-info" v-if="this.offer">
                <p>{{this.offer.Headline}}</p>


                <!--                <div v-if="this.offer.ActiveSc == 'AVAILABLE' && !this.userEnrolledInAll">-->
                <!--                    <a href="javascript:;" @click="showEnrollCardOrActivate" class="button pink tinysize small mTop10 modal-link">Activate</a>-->
                <!--                </div>-->
                <div v-if="this.offer.ActiveSc == 'AVAILABLE'">
                    <a href="/sign_in" class="button pink tinysize small mTop10 modal-link">{{'Sign In'}}</a>
                </div>


                <p class="note fs-4 mt-3" v-if="this.offer.RedemptionType && this.offer.RedemptionType == 'INSTORE'">In-store purchase only</p>
                <p class="note fs-4 mt-3" v-if="this.offer.RedemptionType && this.offer.RedemptionType == 'ONLINE'">Online purchase only</p>
                <p class="note fs-4 mt-3" v-if="this.offer.RedemptionType && this.offer.RedemptionType == 'ONLINE-INSTORE'">ONLINE-INSTORE</p>

                <div class="expires" v-if="isNaN(this.offer.EventEndDate)">{{ 'Expires - ' + formattedEndDate }} </div>
                <div class="expires" v-show="!isNaN(this.offer.EventEndDate)">Expires
                    <span v-if="this.offer.EventEndDate == 1">today</span>
                    <span v-if="this.offer.EventEndDate != 1">
                            {{ 'in ' + this.offer.EventEndDate }}
                        <span v-if="this.offer.EventEndDate > 1">days</span>
                        <span v-if="this.offer.EventEndDate == 1">day</span>
                    </span>
                </div>

                <div class="my-3">
                    <a href="/sign_in" class="txt-grey fs-5">View details</a>
                </div>
            </div>
        </article>

    </div>
</template>

<script>
    import moment from "moment";
    export default {
        name: "LandingPageOfferComponent",
        props: ['offer'],
        methods: {

        },
        mounted() {

        },
        computed: {
            formattedEndDate() {
                return (this.offer && this.offer.EventEndDate) ? moment(this.offer.EventEndDate).format('MM-DD-YYYY') : '';
            }
        },
    }
</script>

<style scoped>

    .add-to-card {
        background-color: grey;
        color:white;
        border-radius: 40px;
        font-size: 4vm;


        border: none;
        /*color: white;*/
        padding: 7px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        /*font-size: 16px;*/
        margin: 4px 2px;
        cursor: pointer;

    }
</style>
